<template>
  <detail-tracking :data="data" :loading="loading" />
</template>

<script>
import { date } from '../../lib/helpers';

export default {
  components: {
    DetailTracking: () => import('../../components/detail/DetailTracking.vue'),
  },
  beforeMount() {
    this.getDetailData();
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    data() {
      return this.$store.state.trackingPengajuan.merchant;
    },
  },
  methods: {
    async getDetailData() {
      this.loading = true;

      await this.$store
        .dispatch('trackingPengajuan/viewMerchant', {
          id: this.$route.params.id,
          date,
        })
        .then(() => {
          if (this.data == null) {
            this.$router.push('/tracking-pengajuan/list');
          }
        });

      this.loading = false;
    },
  },
};
</script>
